<template>
  <div class="card p-3">
    <div class="grid">
      <!-- Titulo Oficios -->
      <div
        class="col-9 xl:col-3 lg:col-3 md:col-4 sm:col-7 p-2 flex justify-content-end"
      >
        <h5 class="p-2 mt-2 tablaTitle">
          <i
            class="fa-solid fa-box-archive fa-shake px-2"
            style="
              --fa-animation-iteration-count: 1;
              --fa-animation-duration: 2.5s;
            "
          ></i>
          Oficios archivados
        </h5>
      </div>
      <!-- Titulo Oficios -->

      <div
        class="col-3 xl:col-2 lg:col-7 md:col-8 sm:col-5 flex justify-content-start"
      >
        <dialogArchivarOficios />
      </div>

      <div class="col-0 xl:col-7 lg:col-7 md:col-0 sm:col-0 p-2"></div>

      <!-- Tabs -->
      <div class="col-12 p-2">
        <div class="card">
          <TabViewVue
            class="tabview-custom tabsTablas"
            :activeIndex="parseInt(selectedTab)"
          >
            <!-- Tabla de Archivados -->
            <TabPanelVue>
              <template #header>
                <div
                  class="divTabs"
                  @click="getFichasArchivadosRecepcion"
                >
                    <!-- Contador para oficios -->
                    <BadgeVue
                      :value="contadorOficiosArchivadosRecepcion"
                      class="titulosPestanasContador"
                    >
                    </BadgeVue>
                    <!-- Contador para oficios -->
                    <i
                      class="fa-solid fa-folder-open fa-bounce px-2"
                      style="
                        --fa-animation-iteration-count: 1;
                        --fa-animation-duration: 2.5s;
                      "
                    ></i>
                    <span>Oficios archivados de recepción</span>
                </div>
              </template>

              <div class="card p-1">
                <DataTable
                  :value="fichasRecepcionArchivados"
                  responsiveLayout="scroll"
                  v-model:filters="filtersArchivados"
                  stripedRows
                  sortField="numeroOficio"
                  :sortOrder="-1"
                  :paginator="true"
                  :rows="10"
                  paginatorTemplate="CurrentPageReport  PrevPageLink PageLinks NextPageLink  RowsPerPageDropdown"
                  :rowsPerPageOptions="[10, 20, 30]"
                  removableSort
                  dataKey="numeroOficio"
                  class="p-datatable-sm"
                  style="width: 100%"
                >
                  <template #header>
                    <div class="grid">
                      <div class="col-12 p-1">
                        <div class="flex justify-content-center">
                          <span class="p-input-icon-left m-2">
                            <i class="pi pi-search" />
                            <InputTextV
                              v-model="filtersArchivados['global'].value"
                              placeholder="Buscar"
                              class="p-inputtext-sm"
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                  </template>

                  <template #empty>
                    <InlineMessageVue
                      severity="info"
                      class="border-dashed border-300"
                    >
                      No se encontraron resultados.
                    </InlineMessageVue>
                  </template>

                  <template #loading>
                    <InlineMessageVue
                      severity="info"
                      class="border-dashed border-300"
                    >
                      Cargando....
                    </InlineMessageVue>
                  </template>

                  <ColumnVue
                    v-for="col of columnasArchivados"
                    :field="col.field"
                    :header="col.header"
                    :key="col.field"
                    :sortable="true"
                    :hidden="col.hidden"
                    class="border-dashed border-300 tablaOficiosData"
                  >
                  </ColumnVue>

                  <ColumnVue
                    :exportable="false"
                    style="width: 18rem"
                    header="Opciones"
                    class="tablaOficiosData"
                  >
                    <template #body="slotProps">
                      <!-- Oficios para Archivados (Adjuntado) -->
                      <SplitButtonVue
                        v-if="
                          slotProps.data.status == 7 &&
                          slotProps.data.adjuntado == 1
                        "
                        icon="fa-solid fa-file fa-bounce"
                        style="--fa-animation-duration: 5s"
                        class="p-button-sm p-button-secondary splitRecepcionEstado15 w-full"
                        label="Oficio archivado adjunto"
                        v-tooltip.top="'El oficio ha sido archivado'"
                        :model="[
                          {
                            label: 'Ver oficio archivado',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio
                              );
                            },
                          },

                          {
                            label: 'Desarchivar oficio',
                            icon: 'pi pi-link',
                            command: () => {
                              openDialogDesarchivar(
                                'DesarchivarOficio',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(slotProps.data);
                            },
                          },
                          ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])
                        ]"
                      />
                      <!-- Oficios para Archivados (Adjuntado) -->

                      <!-- Oficios para Archivados (Creado) -->
                      <SplitButtonVue
                        v-if="
                          slotProps.data.status == 7 &&
                          slotProps.data.adjuntado == 2
                        "
                        icon="fa-regular fa-file fa-bounce"
                        style="--fa-animation-duration: 5s"
                        class="p-button-sm p-button-secondary splitRecepcionEstado15 w-full"
                        label="Oficio archivado creado"
                        v-tooltip.top="'El oficio ha sido archivado'"
                        :model="[
                          {
                            label: 'Ver oficio archivado',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio
                              );
                            },
                          },

                          {
                            label: 'Desarchivar oficio',
                            icon: 'pi pi-link',
                            command: () => {
                              openDialogDesarchivar(
                                'DesarchivarOficio',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(slotProps.data);
                            },
                          },
                          ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])
                        ]"
                      />
                      <!-- Oficios para Archivados (Creado) -->
                    </template>
                  </ColumnVue>
                </DataTable>
              </div>
            </TabPanelVue>
            <!-- Tabla de Archivados -->

            <!-- Tabla de Archivados Atencion -->
            <TabPanelVue>
              <template #header>
                <div
                  class="divTabs"
                  @click="getFichasArchivadosAtencion"
                >
                    <!-- Contador para oficios -->
                    <BadgeVue
                      :value="contadorOficiosArchivadosRecepcionAtencion"
                      class="titulosPestanasContador"
                    >
                    </BadgeVue>
                    <!-- Contador para oficios -->
                    <i
                      class="fa-solid fa-folder-open fa-tags px-2"
                      style="
                        --fa-animation-iteration-count: 1;
                        --fa-animation-duration: 2.5s;
                      "
                    ></i>
                    <span>Oficios archivados con atención</span>
                </div>
              </template>

              <div class="card p-1">
                <DataTable
                  :value="fichasRecepcionArchivadosAtencion"
                  responsiveLayout="scroll"
                  v-model:filters="filtersArchivados"
                  stripedRows
                  sortField="numeroOficio"
                  :sortOrder="-1"
                  :paginator="true"
                  :rows="10"
                  paginatorTemplate="CurrentPageReport  PrevPageLink PageLinks NextPageLink  RowsPerPageDropdown"
                  :rowsPerPageOptions="[10, 20, 30]"
                  removableSort
                  dataKey="numeroOficio"
                  class="p-datatable-sm"
                  style="width: 100%"
                >
                  <template #header>
                    <div class="grid">
                      <div class="col-12 p-1">
                        <div class="flex justify-content-center">
                          <span class="p-input-icon-left m-2">
                            <i class="pi pi-search" />
                            <InputTextV
                              v-model="filtersArchivados['global'].value"
                              placeholder="Buscar"
                              class="p-inputtext-sm"
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                  </template>

                  <template #empty>
                    <InlineMessageVue
                      severity="info"
                      class="border-dashed border-300"
                    >
                      No se encontraron resultados.
                    </InlineMessageVue>
                  </template>

                  <template #loading>
                    <InlineMessageVue
                      severity="info"
                      class="border-dashed border-300"
                    >
                      Cargando....
                    </InlineMessageVue>
                  </template>

                  <ColumnVue
                    v-for="col of columnasArchivados"
                    :field="col.field"
                    :header="col.header"
                    :key="col.field"
                    :sortable="true"
                    :hidden="col.hidden"
                    class="border-dashed border-300 tablaOficiosData"
                  >
                  </ColumnVue>

                  <ColumnVue
                    :exportable="false"
                    style="width: 18rem"
                    header="Opciones"
                    class="tablaOficiosData"
                  >
                    <template #body="slotProps">
                      <!-- Oficios para Archivados (Adjuntado) -->
                      <SplitButtonVue
                        v-if="
                          slotProps.data.status == 7 &&
                          slotProps.data.adjuntado == 1
                        "
                        icon="fa-solid fa-file fa-bounce"
                        style="--fa-animation-duration: 5s"
                        class="p-button-sm p-button-secondary splitRecepcionEstado15 w-full"
                        label="Oficio Archivado Adjunto"
                        v-tooltip.top="'El oficio ha sido Archivado'"
                        :model="[
                          {
                            label: 'Ver oficio archivado',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio
                              );
                            },
                          },

                          {
                            label: 'Desarchivar oficio',
                            icon: 'pi pi-link',
                            command: () => {
                              openDialogDesarchivar(
                                'DesarchivarOficio',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(slotProps.data);
                            },
                          },
                          ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])
                        ]"
                      />
                      <!-- Oficios para Archivados (Adjuntado) -->

                      <!-- Oficios para Archivados (Creado) -->
                      <SplitButtonVue
                        v-if="
                          slotProps.data.status == 7 &&
                          slotProps.data.adjuntado == 2
                        "
                        icon="fa-regular fa-file fa-bounce"
                        style="--fa-animation-duration: 5s"
                        class="p-button-sm p-button-secondary splitRecepcionEstado15 w-full"
                        label="Oficio archivado creado"
                        v-tooltip.top="'El oficio ha sido archivado'"
                        :model="[
                          {
                            label: 'Ver oficio archivado',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio
                              );
                            },
                          },

                          {
                            label: 'Desarchivar oficio',
                            icon: 'pi pi-link',
                            command: () => {
                              openDialogDesarchivar(
                                'DesarchivarOficio',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(slotProps.data);
                            },
                          },
                          ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])
                        ]"
                      />
                      <!-- Oficios para Archivados (Creado) -->
                    </template>
                  </ColumnVue>
                </DataTable>
              </div>
            </TabPanelVue>
            <!-- Tabla de Archivados Atencion -->

            <!-- Tabla de Archivados Turnados-->
            <TabPanelVue>
              <template #header>
                <div
                  class="divTabs"
                  @click="getFichasArchivadosTurnados"
                >
                    <!-- Contador para oficios -->
                    <BadgeVue
                      :value="contadorOficiosArchivadosRecepcionTurnados"
                      class="titulosPestanasContador"
                    >
                    </BadgeVue>
                    <!-- Contador para oficios -->
                    <i
                      class="fa-solid fa-arrows-turn-right fa-bounce px-2"
                      style="
                        --fa-animation-iteration-count: 1;
                        --fa-animation-duration: 2.5s;
                      "
                    ></i>
                    <span>Oficios archivados turnados</span>
                  </div>
              </template>

              <div class="card p-1">
                <DataTable
                  :value="fichasRecepcionArchivadosTurnados"
                  responsiveLayout="scroll"
                  v-model:filters="filtersArchivados"
                  stripedRows
                  sortField="numeroOficio"
                  :sortOrder="-1"
                  :paginator="true"
                  :rows="10"
                  paginatorTemplate="CurrentPageReport  PrevPageLink PageLinks NextPageLink  RowsPerPageDropdown"
                  :rowsPerPageOptions="[10, 20, 30]"
                  removableSort
                  dataKey="numeroOficio"
                  class="p-datatable-sm"
                  style="width: 100%"
                >
                  <template #header>
                    <div class="grid">
                      <div class="col-12 p-1">
                        <div class="flex justify-content-center">
                          <span class="p-input-icon-left m-2">
                            <i class="pi pi-search" />
                            <InputTextV
                              v-model="filtersArchivados['global'].value"
                              placeholder="Buscar"
                              class="p-inputtext-sm"
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                  </template>

                  <template #empty>
                    <InlineMessageVue
                      severity="info"
                      class="border-dashed border-300"
                    >
                      No se encontraron resultados.
                    </InlineMessageVue>
                  </template>

                  <template #loading>
                    <InlineMessageVue
                      severity="info"
                      class="border-dashed border-300"
                    >
                      Cargando....
                    </InlineMessageVue>
                  </template>

                  <ColumnVue
                    v-for="col of columnasArchivados"
                    :field="col.field"
                    :header="col.header"
                    :key="col.field"
                    :sortable="true"
                    :hidden="col.hidden"
                    class="border-dashed border-300 tablaOficiosData"
                  >
                  </ColumnVue>

                  <ColumnVue
                    :exportable="false"
                    style="width: 18rem"
                    header="Opciones"
                    class="tablaOficiosData"
                  >
                    <template #body="slotProps">
                      <!-- Oficios para Archivados (Adjuntado) -->
                      <SplitButtonVue
                        v-if="slotProps.data.adjuntado == 1"
                        icon="fa-solid fa-file fa-bounce"
                        style="--fa-animation-duration: 5s"
                        class="p-button-sm p-button-secondary splitRecepcionEstado15 w-full"
                        label="Oficio archivado adjunto"
                        v-tooltip.top="'El oficio ha sido archivado'"
                        :model="[
                          {
                            label: 'Ver oficio archivado',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio
                              );
                            },
                          },

                          {
                            label: 'Desarchivar oficio turnado',
                            icon: 'pi pi-link',
                            command: () => {
                              openDialogDesarchivar(
                                'DesarchivarOficioTurnado',
                                slotProps.data
                              );
                            },
                          },

                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(slotProps.data);
                            },
                          },
                          ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])
                        ]"
                      />
                      <!-- Oficios para Archivados (Adjuntado) -->

                      <!-- Oficios para Archivados (Creado) -->
                      <SplitButtonVue
                        v-if="slotProps.data.adjuntado == 2"
                        icon="fa-regular fa-file fa-bounce"
                        style="--fa-animation-duration: 5s"
                        class="p-button-sm p-button-secondary splitRecepcionEstado15 w-full"
                        label="Oficio archivado creado"
                        v-tooltip.top="'El oficio ha sido archivado'"
                        :model="[
                          {
                            label: 'Ver oficio archivado',
                            icon: 'pi pi-eye',
                            command: () => {
                              openDialog(
                                'VisualizarPDF',
                                slotProps.data.idOficio
                              );
                            },
                          },

                          {
                            label: 'Desarchivar oficio turnado',
                            icon: 'pi pi-link',
                            command: () => {
                              openDialogDesarchivar(
                                'DesarchivarOficioTurnado',
                                slotProps.data
                              );
                            },
                          },
                          {
                            label: 'Visualizar bitácora',
                            icon: 'pi pi-book',
                            command: () => {
                              toggleBitacora(slotProps.data);
                            },
                          },
                          ...(slotProps.data.anexo == 1 ? [
                            {
                              label: 'Descargar anexo',
                              icon: 'pi pi-download',
                              command: () => {
                                descargarAnexos(slotProps.data.idOficio)
                              },
                            },

                          ] : [])
                        ]"
                      />
                      <!-- Oficios para Archivados (Creado) -->
                    </template>
                  </ColumnVue>
                </DataTable>
              </div>
            </TabPanelVue>
            <!-- Tabla de Archivados Turnados-->
          </TabViewVue>
        </div>
      </div>
      <!-- Tabs -->
    </div>
  </div>

  <dialogVisualizarPDFBuzon v-if="hasRole('VisualizarPDF')" />
  <dialogDesarchivarOficio
    @valor="limpiarFilter"
    v-if="hasRole('DesarchivarOficio')"
  />
  <dialogDesarchivarOficioTurnado
    @valor="limpiarFilter"
    v-if="hasRole('DesarchivarOficioTurnado')"
  />
  <DialogVue
    v-model:visible="visibleBitacora"
    modal
    style="width: 60%"
    pt:root:class="!border-0"
    pt:mask:class="backdrop-blur-sm"
  >
    <template #container="{ closeCallback }">
      <div
        class="flex flex-column"
        style="background-color: white; position: relative"
      >
        <span
          @click="closeCallback"
          style="
            width: 100%;
            text-align: right;
            font-size: 21px;
            top: 8px;
            right: 18px;
            cursor: pointer;
            position: absolute;
          "
          >X</span
        >

        <TabMenu class="m-0" v-model:activeIndex="tabVista" :model="items" />
        <div
          class="flex flex-row justify-content-center flex-wrap px-6"
          style="
            height: 600px;
            border-radius: 12px;
            border-top-left-radius: 0;
            border-top-right-radius: 0;
            overflow-y: scroll;
            background: white;
            position: relative;
          "
        >
          <h2 v-if="valueBitacora.length == 0" class="text-3xl text-gray-900">
            No hay movimientos
          </h2>
          <CardVue
            class="m-3"
            style="width: 300px"
            v-for="(element, index) of valueBitacora"
            :key="element.usuario + index"
          >
            <template #title>Movimiento #{{ index + 1 }}</template>
            <template #content>
              <ul>
                <li>
                  Accion: <strong>{{ element.accion }}</strong>
                </li>
                <li>
                  Fecha: <strong>{{ element.fecha }}</strong>
                </li>
                <li>
                  Hora: <strong>{{ element.hora }}</strong>
                </li>
                <li>
                  Usuario: <strong>{{ element.usuario }}</strong>
                </li>
              </ul>
            </template>
          </CardVue>
          <ButtonVue
            label="Cerrar"
            @click="closeCallback"
            text
            style="width: fit-content"
            class="!p-4 w-full !text-primary-50 !border !border-white/30 hover:!bg-white/10"
          ></ButtonVue>
        </div>
      </div>
    </template>
  </DialogVue>
</template>

<script>
import { ref, onMounted, defineAsyncComponent } from "vue";
import DataTable from "primevue/datatable";
import useOficiosRecepcion from "../composables/useOficiosRecepcion";
import dialogArchivarOficios from "../components/oficiosLibres/dialogAyudaArchivarOficios";
import Swal from "sweetalert2";
//Tabla Buzon
import useOpenDialogs from "../composables/useOpenDialogs";
//Tabla Buzon
import { useRoute } from "vue-router";
import api from "@/api/laravelApi";
import TabMenu from "primevue/tabmenu";
import useOficiosList from "../composables/useOficiosCreacion";

export default {
  components: {
    //OficiosPendientes
    TabMenu,
    DataTable,
    dialogArchivarOficios,
    dialogVisualizarPDFBuzon: defineAsyncComponent(() =>
      import(
        "../components/oficiosLibres/oficiosCreados/dialogVisualizarPDF.vue"
      )
    ),
    dialogDesarchivarOficio: defineAsyncComponent(() =>
      import(
        "../components/oficiosLibres/oficiosArchivados/dialogDesarchivarOficio.vue"
      )
    ),
    dialogDesarchivarOficioTurnado: defineAsyncComponent(() =>
      import(
        "../components/oficiosLibres/oficiosArchivados/dialogDesarchivarOficioTurnado.vue"
      )
    ),
    //OficiosPendientes
  },
  watch: {
    visibleBitacora(value) {
      if (value == false) {
        this.tabVista = 0;
      }
    },
  },

  setup() {
    /* const route = useRoute(); */
    /* const { code } = route.query; */
    const route = useRoute();
    const selectedTab = ref(route.params.tab);

    const { openDialog, openDialogDesarchivar, hasRole, toggleDialog } =
      useOpenDialogs();

    //Tabla de para consumir
    const {
      columns,
      columnasArchivados,
      filtersArchivados,
      fichasRecepcionArchivados,
      fichasRecepcionArchivadosAtencion,
      fichasRecepcionArchivadosTurnados,
      getFichasRecepcionArchivados,
      getFichasRecepcionArchivadosAtencion,
      getFichasRecepcionArchivadosTurnados,
      fichas,

      contadorOficiosArchivadosRecepcion,
      contadorOficiosArchivadosRecepcionAlt,
      barraOficiosArchivadosRecepcion,

      contadorOficiosArchivadosRecepcionAtencion,
      contadorOficiosArchivadosRecepcionAtencionAlt,
      barraOficiosArchivadosRecepcionAtencion,

      contadorOficiosArchivadosRecepcionTurnados,
      contadorOficiosArchivadosRecepcionTurnadosAlt,
      barraOficiosArchivadosRecepcionTurnados,
    } = useOficiosRecepcion();

    const messages = ref([]);
    const count = ref(0);
    const addMessages = () => {
      messages.value = [
        {
          icon: "pi pi-search",
          severity: "info",
          content: "Dynamic Info Message",
          id: count.value++,
        },
      ];
    };

    const{descargarAnexos} = useOficiosList()

    const getFichasArchivadosRecepcion = async () => {
      new Swal({
        title: "Cargando...",
        text: "Actualizando información de oficios archivados",
        allowOutsideClick: false,
      });
      Swal.showLoading();
      const { ok, message } = await getFichasRecepcionArchivados();
      if (!ok) Swal.fire("Error", message, "error");
      else {
        Swal.close();
        window.dispatchEvent(new Event("cantidadOficiosFirmar"));
      }

      await barraOficiosArchivadosRecepcion();
      await barraOficiosArchivadosRecepcionAtencion();
      await barraOficiosArchivadosRecepcionTurnados();
    };

    const getFichasArchivadosAtencion = async () => {
      new Swal({
        title: "Cargando...",
        text: "Actualizando información de oficios archivados con atencion",
        allowOutsideClick: false,
      });
      Swal.showLoading();
      const { ok, message } = await getFichasRecepcionArchivadosAtencion();
      if (!ok) Swal.fire("Error", message, "error");
      else {
        Swal.close();
        window.dispatchEvent(new Event("cantidadOficiosFirmar"));
      }

      await barraOficiosArchivadosRecepcion();
      await barraOficiosArchivadosRecepcionAtencion();
      await barraOficiosArchivadosRecepcionTurnados();
    };

    const getFichasArchivadosTurnados = async () => {
      new Swal({
        title: "Cargando...",
        text: "Actualizando información de oficios archivados turnados",
        allowOutsideClick: false,
      });
      Swal.showLoading();
      const { ok, message } = await getFichasRecepcionArchivadosTurnados();
      if (!ok) Swal.fire("Error", message, "error");
      else {
        Swal.close();
        window.dispatchEvent(new Event("cantidadOficiosFirmar"));
      }

      await barraOficiosArchivadosRecepcion();
      await barraOficiosArchivadosRecepcionAtencion();
      await barraOficiosArchivadosRecepcionTurnados();
    };

    const getAll = async () => {
      await api
        .get("oficios/cantidadOficios")
        .then((response) => {
          const dataNum = response.data.data;
          localStorage.setItem("cantidadOficios", JSON.stringify(dataNum));

          if (localStorage.getItem("cantidadOficios") !== null) {
            const data = JSON.parse(localStorage.getItem("cantidadOficios"));
            contadorOficiosArchivadosRecepcion.value = data.archivado_recepcion;
            contadorOficiosArchivadosRecepcionAlt.value =
              data.archivado_recepcion;
            contadorOficiosArchivadosRecepcionAtencion.value =
              data.archivado_atencion;
            contadorOficiosArchivadosRecepcionAtencionAlt.value =
              data.archivado_atencion;
            contadorOficiosArchivadosRecepcionTurnados.value =
              data.archivado_turnados;
            contadorOficiosArchivadosRecepcionTurnadosAlt.value =
              data.archivado_turnados;
          }
        })
        .catch((err) => {
          new Swal({
            title: "Error",
            text: err,
            allowOutsideClick: false,
          });
        });
    };

    onMounted(async () => {
      new Swal({
        title: "Cargando...",
        text: "Actualizando información del directorio de archivados de oficios",
        allowOutsideClick: false,
      });
      Swal.showLoading();

      await getFichasRecepcionArchivados();
      await getFichasRecepcionArchivadosAtencion();
      await getFichasRecepcionArchivadosTurnados();

      Swal.close();

      await barraOficiosArchivadosRecepcion();
      await barraOficiosArchivadosRecepcionAtencion();
      await barraOficiosArchivadosRecepcionTurnados();

      window.addEventListener("cantidadOficiosFirmar", getAll);
    });

    const limpiarFilter = () => {
      filtersArchivados.value = {
        ...filtersArchivados.value,
        global: { value: "", matchMode: "contains" },
      };
    };

    const visibleBitacora = ref(false);
    const valueBitacora = ref([]);
    const saveOficio = ref("");
    const tabVista = ref(0);

    const toggleBitacora = async (data, tab = 1) => {
      Swal.showLoading();
      Swal.isLoading();
      visibleBitacora.value = true;
      saveOficio.value = { idOficio: data.idOficio };
      await api
        .get(`bitacora/${data.idOficio}/${tab}`)
        .then((response) => {
          valueBitacora.value = response.data.data.reverse();
          Swal.close();
        })
        .catch((error) => {
          // console.log(error)
          new Swal({
            title: "Error",
            text: error,
            allowOutsideClick: false,
          });
          Swal.close();
        });
    };
    const items = ref([
      {
        label: "Movimientos de oficio",
        icon: "pi pi-list",
        command: () => {
          toggleBitacora(saveOficio.value, 1);
        },
      },
      {
        label: "Vistas de oficio",
        icon: "pi pi-inbox",
        command: () => {
          toggleBitacora(saveOficio.value, 2);
        },
      },
    ]);

    return {
      visibleBitacora,
      tabVista,
      items,
      toggleBitacora,
      valueBitacora,
      fichasRecepcionArchivados,
      fichasRecepcionArchivadosAtencion,
      fichasRecepcionArchivadosTurnados,
      columns,
      columnasArchivados,
      filtersArchivados,
      fichas,
      addMessages,
      hasRole,
      openDialog,
      openDialogDesarchivar,
      toggleDialog,
      dialogArchivarOficios,
      getFichasArchivadosRecepcion,
      getFichasArchivadosAtencion,
      getFichasArchivadosTurnados,

      contadorOficiosArchivadosRecepcion,
      contadorOficiosArchivadosRecepcionAlt,
      barraOficiosArchivadosRecepcion,

      contadorOficiosArchivadosRecepcionAtencion,
      contadorOficiosArchivadosRecepcionAtencionAlt,
      barraOficiosArchivadosRecepcionAtencion,

      contadorOficiosArchivadosRecepcionTurnados,
      contadorOficiosArchivadosRecepcionTurnadosAlt,
      barraOficiosArchivadosRecepcionTurnados,
      selectedTab,
      limpiarFilter,
      descargarAnexos,
    };
  },
};
</script>

<style scoped lang="scss">
::v-deep(.titulosPestanasContador) {
  font-size: 9px;
  background-color: rgb(18, 95, 168);
  // background-color: #bec3c9;
}
.coloraux1 {
  background: #4a001f;
  font-size: 13px;
  font-weight: lighter;
}

.coloraux2 {
  background: #919191;
  font-size: 12px;
  font-weight: lighter;
}

.buttonAbrirOficio {
  background-color: #4a001f;
}

::v-deep(.cardEntrada) {
  background-color: rgb(185, 185, 185);
  .p-card-title {
    font-size: 14px;
  }
  .p-card-content {
    font-size: 12px;
  }
}

::v-deep(.tablaOficiosData) {
  font-size: 13px;
  .p-column-title {
    font-size: 13px;
  }
}

::v-deep(.tabsTablas) {
  .p-tabview-nav {
    font-size: 13px;
  }
}

.titleaccordion {
  font-size: 13px;
}

::v-deep(.columnasOcultas) {
  font-size: 1px;
  padding-bottom: 1px;
  display: block;
  color: red;
  .p-datatable-thead {
    color: red;
    display: block;
  }
}

::v-deep(.botonAyuda) {
  .p-button-icon {
    font-size: 25px;
    transition: ease 1s;
  }
}

::v-deep(.botonAyuda:hover) {
  .p-button-icon {
    font-size: 25px;
    color: rgb(77, 77, 77);
    transition: ease 1s;
  }
}

@media only screen and (max-width: 600px) {
  .tablaTitle {
    font-size: 15px;
    transition: ease 1s;
  }

  .titulosPestanas {
    height: 45px;
    width: 85px;
    transition: ease 1s;
  }

  ::v-deep(.botonAyuda) {
    .p-button-icon {
      font-size: 15px;
      transition: ease 1s;
    }
  }

  ::v-deep(.botonAyuda:hover) {
    .p-button-icon {
      font-size: 15px;
      color: rgb(77, 77, 77);
      transition: ease 1s;
    }
  }

  ::v-deep(.tablaOficiosData) {
    font-size: 10px;
    transition: ease 1s;
    .p-column-title {
      font-size: 12px;
    }
  }

  ::v-deep(.tabsTablas) {
    .p-tabview-nav {
      font-size: 10.5px;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado15) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #393939 !important;
      border-color: #393939 !important;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado15:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #131313 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstadoDesarchivado) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #22669d !important;
      border-color: #22669d !important;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstadoDesarchivado:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #133957 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }
}

@media only screen and (min-width: 600px) {
  .tablaTitle {
    font-size: 18px;
    transition: ease 1s;
  }

  .titulosPestanas {
    height: 55px;
    width: 85px;
    transition: ease 1s;
  }

  ::v-deep(.botonAyuda) {
    .p-button-icon {
      font-size: 18px;
      transition: ease 1s;
    }
  }

  ::v-deep(.botonAyuda:hover) {
    .p-button-icon {
      font-size: 18px;
      color: rgb(77, 77, 77);
      transition: ease 1s;
    }
  }

  ::v-deep(.tablaOficiosData) {
    font-size: 12px;
    transition: ease 1s;
    .p-column-title {
      font-size: 13px;
    }
  }

  ::v-deep(.tabsTablas) {
    .p-tabview-nav {
      font-size: 11px;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado15) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #393939 !important;
      border-color: #393939 !important;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado15:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #131313 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstadoDesarchivado) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #22669d !important;
      border-color: #22669d !important;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstadoDesarchivado:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #133957 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }
}

@media only screen and (min-width: 768px) {
  .tablaTitle {
    font-size: 14px;
    transition: ease 1s;
  }

  .titulosPestanas {
    height: 55px;
    width: 125px;
    transition: ease 1s;
  }

  ::v-deep(.botonAyuda) {
    .p-button-icon {
      font-size: 20px;
      transition: ease 1s;
    }
  }

  ::v-deep(.botonAyuda:hover) {
    .p-button-icon {
      font-size: 20px;
      color: rgb(77, 77, 77);
      transition: ease 1s;
    }
  }

  ::v-deep(.tablaOficiosData) {
    font-size: 12px;
    transition: ease 1s;
    .p-column-title {
      font-size: 13px;
    }
  }

  ::v-deep(.tabsTablas) {
    .p-tabview-nav {
      font-size: 12px;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado15) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #393939 !important;
      border-color: #393939 !important;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado15:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #131313 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstadoDesarchivado) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #22669d !important;
      border-color: #22669d !important;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstadoDesarchivado:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #133957 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }
}

@media only screen and (min-width: 992px) {
  .tablaTitle {
    font-size: 16px;
    transition: ease 1s;
  }

  .titulosPestanas {
    height: 35px;
    width: 155px;
    transition: ease 1s;
  }

  ::v-deep(.botonAyuda) {
    .p-button-icon {
      font-size: 21px;
      transition: ease 1s;
    }
  }

  ::v-deep(.botonAyuda:hover) {
    .p-button-icon {
      font-size: 21px;
      color: rgb(77, 77, 77);
      transition: ease 1s;
    }
  }

  ::v-deep(.tablaOficiosData) {
    font-size: 13px;
    transition: ease 1s;
    .p-column-title {
      font-size: 13px;
    }
  }

  ::v-deep(.tabsTablas) {
    .p-tabview-nav {
      font-size: 11px;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado15) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #393939 !important;
      border-color: #393939 !important;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado15:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #131313 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstadoDesarchivado) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #22669d !important;
      border-color: #22669d !important;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstadoDesarchivado:hover) {
    .p-component {
      font-size: 10px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #133957 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }
}

@media only screen and (min-width: 1200px) {
  .tablaTitle {
    font-size: 20px;
    transition: ease 1s;
  }

  .titulosPestanas {
    height: 50px;
    width: 180px;
    transition: ease 1s;
  }

  ::v-deep(.botonAyuda) {
    .p-button-icon {
      font-size: 22px;
      transition: ease 1s;
    }
  }

  ::v-deep(.botonAyuda:hover) {
    .p-button-icon {
      font-size: 22px;
      color: rgb(77, 77, 77);
      transition: ease 1s;
    }
  }

  ::v-deep(.tablaOficiosData) {
    font-size: 16px;
    transition: ease 1s;
    .p-column-title {
      font-size: 16px;
    }
  }

  ::v-deep(.tabsTablas) {
    .p-tabview-nav {
      font-size: 14px;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado15) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #393939 !important;
      border-color: #393939 !important;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado15:hover) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #131313 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstadoDesarchivado) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #22669d !important;
      border-color: #22669d !important;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstadoDesarchivado:hover) {
    .p-component {
      font-size: 15px !important;
      height: 50px !important;
      max-height: 50px !important;

      background-color: #133957 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }
}

@media only screen and (min-width: 1515px) {
  .tablaTitle {
    font-size: 20px;
    transition: ease 1s;
  }

  .titulosPestanas {
    height: 40px;
    width: 175px;
    transition: ease 1s;
  }

  ::v-deep(.botonAyuda) {
    .p-button-icon {
      font-size: 25px;
      transition: ease 1s;
    }
  }

  ::v-deep(.botonAyuda:hover) {
    .p-button-icon {
      font-size: 25px;
      color: rgb(77, 77, 77);
      transition: ease 1s;
    }
  }

  ::v-deep(.tablaOficiosData) {
    font-size: 13px;
    transition: ease 1s;
    .p-column-title {
      font-size: 13px;
    }
  }

  ::v-deep(.tabsTablas) {
    .p-tabview-nav {
      font-size: 13px;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado15) {
    .p-component {
      font-size: 13px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #393939 !important;
      border-color: #393939 !important;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstado15:hover) {
    .p-component {
      font-size: 13px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #131313 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstadoDesarchivado) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #22669d !important;
      border-color: #22669d !important;
      transition: ease 1s;
    }
  }

  ::v-deep(.splitRecepcionEstadoDesarchivado:hover) {
    .p-component {
      font-size: 8px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #133957 !important;
      border-color: #ffffff !important;
      border-style: dotted;
      transition: ease 1s;
    }
  }
}
</style>
